import React from 'react';
import './CreateCampaignGuide.css';

const CreateCampaignGuide = () => {
  return (
    <div className='CreateCampaignGuide-Container'>
      <h2>CreateCampaignGuide</h2>
    
    </div>
  );
};

export default CreateCampaignGuide;
